export const isWin = () => navigator.platform.indexOf("Win") !== -1;
